import clsx from 'clsx';
import type { ForwardedRef } from 'react';

import type { MaterialIcon } from '../../../types/icons';
import type { Size } from '../../../types/layout';

/**
 * List of icons: https://fonts.google.com/icons?icon.set=Material+Icons
 *
 * @example
 * <Icon size="sm" icon="home" outlined />
 */

export interface SgIconProps {
  ref?: ForwardedRef<HTMLElement>;
  icon: MaterialIcon;
  // color?: Color
  size?: Size;
  outlined?: boolean;
  className?: string;
  'data-e2e'?: string;
}

export const SgIcon = (props: SgIconProps) => {
  const { icon, size = 'md', ref, outlined = false, 'data-e2e': dataE2e, className } = props;

  return (
    <i
      ref={ref}
      className={clsx([`icon icon-${size}`, className], {
        'icon-outlined': outlined,
      })}
      data-e2e={dataE2e}
    >
      {icon}
    </i>
  );
};
